/* Toggle native filter sidebar and collection layout only. */
(() => {
  if (window.afordaToolbarReady) return;
  window.afordaToolbarReady = true;
  document.addEventListener('click', e => {
    const section = e.target.closest('.shopify-section');
    const layout = section?.querySelector('.aforda-sidebar-layout');
    if (!layout) return;
    const toggle = e.target.closest('.aforda-filters-toggle');
    if (toggle) {
      const hidden = layout.classList.toggle('aforda-hide-filters');
      toggle.setAttribute('aria-expanded', String(!hidden));
      toggle.querySelector('span').textContent = hidden ? 'Show filters' : 'Hide filters';
      return;
    }
    const btn = e.target.closest('[data-aforda-view]');
    if (!btn) return;
    const list = btn.dataset.afordaView === 'list';
    layout.classList.toggle('aforda-list-view',list);
    section.querySelectorAll('[data-aforda-view]').forEach(b => {
      const active = b === btn;
      b.classList.toggle('is-active',active);
      b.setAttribute('aria-pressed',String(active));
    });
  });
})();